<template>

  <el-form label-position="left" label-width="auto" size="small" require-asterisk-position="right">


    <el-collapse :accordion="true" v-model="collapse">
      <el-collapse-item title="数据源" name="数据源">

        <dataset-datasource :element="element" @handle-form-change="handleFormChange"></dataset-datasource>

      </el-collapse-item>
      <el-collapse-item v-if="element.dataset.source" title="主任务" name="主任务">
        <el-form-item label="项目名称" required>
          <el-select v-model="setting.name">
            <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='dimension')" :key="index"
                       :label="column.label" :value="column.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="setting.status">
            <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='dimension')" :key="index"
                       :label="column.label" :value="column.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-select v-model="setting.start">
            <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='date')" :key="index"
                       :label="column.label" :value="column.label"></el-option>
          </el-select>
        </el-form-item>
        <div style="margin: 10px 0">结束日期 / 持续天数 选择其一即可</div>
        <el-form-item label="结束日期">
          <el-select v-model="setting.end">
            <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='date')" :key="index"
                       :label="column.label" :value="column.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="持续时间（天）">
          <el-select v-model="setting.duration">
            <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='index')" :key="index"
                       :label="column.label" :value="column.label"></el-option>
          </el-select>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item v-if="element.dataset.source" title="子任务" name="子任务">

        <div v-for="(child,childIndex) in setting.children" :key="childIndex"
             style="padding: 10px;border: 1px solid #E4E7EC;border-radius: 15px;
             background: rgba(247,249,252,0.2);margin-bottom: 20px; ">

          <el-form label-width="auto" size="small" label-position="left">
            <el-form-item label="任务名称" required>
              <el-input v-model="child.name"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="child.status">
                <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='dimension')" :key="index"
                           :label="column.label" :value="column.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期">
              <el-select v-model="child.start">
                <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='date')" :key="index"
                           :label="column.label" :value="column.label"></el-option>
              </el-select>
            </el-form-item>
            <div style="margin: 10px 0">结束日期 / 持续天数 选择其一即可</div>
            <el-form-item label="结束日期">
              <el-select v-model="child.end">
                <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='date')" :key="index"
                           :label="column.label" :value="column.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="持续时间（天）">
              <el-select v-model="child.duration">
                <el-option v-for="(column,index) in columns.filter(filter=>filter.tag==='index')" :key="index"
                           :label="column.label" :value="column.label"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="操作">
              <el-button icon="Delete" type="danger" @click="setting.children.splice(childIndex,1)"></el-button>
            </el-form-item>


          </el-form>


        </div>

        <div style="margin: 20px 0;text-align: center">
          <el-button style="width: 80%;height: 30px;font-size: 14px;font-weight: normal"
                     icon="Plus" @click="setting.children.push({
           name: '',start: '',end: '', duration: '',
          })" plain>添加
          </el-button>
        </div>

      </el-collapse-item>
      <el-collapse-item title="显示设置" name="显示设置">
        <el-form-item label="初始缩放">
          <el-select v-model="setting.initialScale" placeholder="请选择初始缩放级别" style="width: 120px">
            <el-option label="小时" value="hour"></el-option>
            <el-option label="天" value="day"></el-option>
            <el-option label="周" value="week"></el-option>
            <el-option label="月" value="month"></el-option>
            <el-option label="季度" value="quarter"></el-option>
            <el-option label="年" value="year"></el-option>
          </el-select>
        </el-form-item>
      </el-collapse-item>
      <el-collapse-item title="快速查看" name="条件设置">
        <div style="margin-bottom: 10px">别名</div>
        <el-form-item label="一级标题">
          <el-input v-model="setting.quickLook.alias['一级标题']"></el-input>
        </el-form-item>
        <el-form-item label="二级标题">
          <el-input v-model="setting.quickLook.alias['二级标题']"></el-input>
        </el-form-item>
      </el-collapse-item>

    </el-collapse>


    <div style="margin: 20px 0;text-align: center">
      <el-button type="primary" style="width: 80%;height: 30px;font-size: 14px;font-weight: normal" @click="preview">预
        览
      </el-button>
    </div>

  </el-form>

</template>

<script>
import {mapStores} from "pinia";
import {useReportStore} from "@/stores/report";
import chartFactory from "@/components/design-report/chartFactory";
import DatasetDatasource from "@/components/design-report/dataset/dataset-datasource.vue";

export default {
  components: {DatasetDatasource},
  props: {
    element: {
      type: Object,
      default: () => {
      }
    },
    elements: {
      type: Array,
      default: () => []
    },
    report: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapStores(useReportStore),
  },
  data() {
    return {
      collapse: '数据源',
      ele: null,
      columns: [],
      setting: {
        name: '',
        start: '',
        end: '',
        duration: '',
        children: [],
        initialScale: 'month',
      },
    }
  },
  created() {
    this.ele = this.element;
    this.setting = this.element.setting;

    // 确保设置对象包含timeUnit和initialScale属性
    if (!this.setting.timeUnit) {
      this.setting.timeUnit = 'day';
    }

    if (!this.setting.initialScale) {
      this.setting.initialScale = 'day';
    }


    if(!this.setting.quickLook){
      this.setting.quickLook = {
        alias: {
          '一级标题': '',
          '二级标题': ''
        }
      }
    }

    if (this.ele.dataset.type && this.ele.dataset.source && this.ele.dataset.source.startsWith("form")) {
      this.getColumns();
    }
  },
  methods: {
    getColumns() {
      this.reportStore.columns(this.ele).then(res => {
        this.columns = res.data;
      })
    },
    handleFormChange(val) {
      this.collapse = "主任务";
      this.getColumns();
    },
    preview() {

      let dimensions = [this.setting.name];
      let dates = [this.setting.start, this.setting.end]

      if (this.setting.status) {
        dimensions.push(this.setting.status)
      }

      this.setting.children.forEach(child => {
        dates.push(child.start);
        dates.push(child.end)

        if (child.status) {
          dimensions.push(child.status)
        }
      })

      dates = dates.filter(filter => filter);

      this.ele.dataset.dimensions = dimensions;
      this.ele.dataset.dates = dates;

      this.loading = true;

      chartFactory.preview(this.report.id, this.element, this.elements, () => {
        this.loading = false;
        //Todo 数据预览后需要做的事情
      });

    }

  }


}

</script>

<style scoped lang="scss">


.el-input{
  width: 200px;
}

</style>